import React from 'react';
import { Component } from "puzzle"
import classNames from "classnames";

export type PROPS = {};

export type STATE = {
  numberOfSelectedSubmissions: number,
  items: phaseItem[]
  phasesForDownload: string[]
}

export type phaseItem = {
  phaseName: string,
  numberOfFiles: number
}

export type ajax_response = {
  items: phaseItem[]
  success: true
}

class MassDownload extends Component<PROPS, STATE> {

  public state: STATE = {
    numberOfSelectedSubmissions: 1,
    items: [],
    phasesForDownload: []
  };

  /**
   * Loads phases data
   * @param phases
   * @param submissions
   */
  loadPhases = (phases: ajax_response, submissions: any) => {
    const numberOfSelected = submissions ? submissions.length : 1;
    this.setState({
      items: phases.items,
      numberOfSelectedSubmissions: numberOfSelected
    });
  };


  /**
   * On check change handler (phases checkbox handler)
   * @param phaseName
   * @param checked
   */
  onCheckChange = (phaseName: string, checked: boolean) => {
    const { phasesForDownload } = this.state;
    if (checked) {
      this.setState({
        phasesForDownload: phasesForDownload.concat(phaseName)
      })
    } else {
      this.setState({
        phasesForDownload: phasesForDownload.filter((item) => {
          return item !== phaseName;
        })
      })
    }
  };

  /**
   * Creates items
   * @param file
   */
  createDownloadableItems = (file: phaseItem) => {
    const { numberOfFiles } = file;
    const classes = classNames(
      "tp-mass-downloadable-item",
      {
        "k-state-disabled": !numberOfFiles
      }
    );
    return (
      <div key={"itemName" + file.phaseName}
           className={classes}>
        <input type={"checkbox"}
               onChange={(e) => this.onCheckChange(file.phaseName, e.target.checked)} />
        <span className="tp-mass-downloadable-item-name">
          {file.phaseName}
          <span className="tp-mass-downloadable-item-file-number">
            {this.translate('files', { numberOfFiles: numberOfFiles })}
          </span>
        </span>
      </div>
    )
  };

  renderBody = () => {
    const { items, numberOfSelectedSubmissions } = this.state;
    const downloadableItems = items.map(this.createDownloadableItems);
    return (
      <div className={'tp-mass-download-content-wrapper'}>
        <div className={'tp-mass-download-selected-submissions'}>
          {this.translate('submissionText', {numberOfSelectedSubmissions})}
        </div>
        {downloadableItems}
      </div>
    );
  }
}

export default MassDownload;
